'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Select = exports.SelectNativeControl = exports.SelectBottomLine = exports.SelectSelectedText = exports.SelectLabel = exports.SelectSurface = exports.SelectRoot = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _mdc = require('@material/select/dist/mdc.select');

var _Base = require('../Base');

var _MDCFoundation = require('../Base/MDCFoundation');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SelectRoot = exports.SelectRoot = (0, _Base.simpleTag)({
  displayName: 'SelectRoot',
  classNames: function classNames(props) {
    return ['mdc-select', {
      'mdc-select--box': props.box
    }];
  },
  consumeProps: ['box'],
  defaultProps: {
    role: 'listbox'
  }
});

var SelectSurface = exports.SelectSurface = (0, _Base.simpleTag)({
  displayName: 'SelectSurface',
  classNames: 'mdc-select__surface'
});

var SelectLabel = exports.SelectLabel = (0, _Base.simpleTag)({
  displayName: 'SelectLabel',
  classNames: function classNames(props) {
    return ['mdc-select__label'];
  }
});

var SelectSelectedText = exports.SelectSelectedText = (0, _Base.simpleTag)({
  displayName: 'SelectSelectedText',
  classNames: 'mdc-select__selected-text'
});

var SelectBottomLine = exports.SelectBottomLine = (0, _Base.simpleTag)({
  displayName: 'SelectBottomLine',
  classNames: 'mdc-select__bottom-line'
});

var SelectNativeControl = exports.SelectNativeControl = (0, _Base.simpleTag)({
  displayName: 'SelectNativeControl',
  tag: 'select',
  classNames: 'mdc-select__native-control'
});

/**
 * Takes multiple structures for options and returns [{label: 'label', value: 'value', ...rest}]
 */
var createSelectOptions = function createSelectOptions(options) {
  // preformatted array
  if (Array.isArray(options) && options[0] && _typeof(options[0]) === 'object') {
    return options.map(function (opt) {
      return Object.assign({}, opt, { options: createSelectOptions(opt.options) });
    });
  }

  // simple array
  if (Array.isArray(options)) {
    return options.map(function (value) {
      return { value: value, label: value };
    });
  }

  // value => label objects
  if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
    return Object.entries(options).map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          value = _ref2[0],
          label = _ref2[1];

      return {
        value: value,
        label: label
      };
    });
  }

  // default, just return
  return options;
};

var Select = exports.Select = function (_withFoundation) {
  _inherits(Select, _withFoundation);

  function Select() {
    _classCallCheck(this, Select);

    return _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).apply(this, arguments));
  }

  _createClass(Select, [{
    key: 'syncWithProps',
    value: function syncWithProps(nextProps) {
      var _this2 = this;

      //disabled
      (0, _MDCFoundation.syncFoundationProp)(nextProps.disabled, this.disabled, function () {
        return _this2.disabled = nextProps.disabled;
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          placeholder = _props.placeholder,
          children = _props.children,
          value = _props.value,
          _props$label = _props.label,
          label = _props$label === undefined ? '' : _props$label,
          _props$options = _props.options,
          options = _props$options === undefined ? [] : _props$options,
          box = _props.box,
          className = _props.className,
          _props$rootProps = _props.rootProps,
          rootProps = _props$rootProps === undefined ? {} : _props$rootProps,
          rest = _objectWithoutProperties(_props, ['placeholder', 'children', 'value', 'label', 'options', 'box', 'className', 'rootProps']);

      var root_ = this.foundationRefs.root_;

      var selectOptions = createSelectOptions(options);

      return React.createElement(
        SelectRoot,
        Object.assign({}, rootProps, {
          box: box,
          elementRef: root_,
          className: this.classes
        }),
        React.createElement(
          SelectNativeControl,
          Object.assign({}, rest, {
            value: value,
            defaultValue: value ? undefined : ''
          }),
          (!!placeholder || placeholder === '') && React.createElement(
            'option',
            { value: '', disabled: placeholder === '' },
            placeholder
          ),
          selectOptions && selectOptions.map(function (_ref3, i) {
            var label = _ref3.label,
                options = _ref3.options,
                option = _objectWithoutProperties(_ref3, ['label', 'options']);

            if (options) {
              return React.createElement(
                'optgroup',
                { tag: 'optgroup', label: label, key: label },
                options.map(function (_ref4, i) {
                  var label = _ref4.label,
                      option = _objectWithoutProperties(_ref4, ['label']);

                  return React.createElement(
                    'option',
                    Object.assign({ key: label }, option, { value: option.value }),
                    label
                  );
                })
              );
            }

            return React.createElement(
              'option',
              Object.assign({ key: label }, option, { value: option.value }),
              label
            );
          }),
          children
        ),
        React.createElement(
          SelectLabel,
          null,
          label
        ),
        React.createElement(SelectBottomLine, null)
      );
    }
  }]);

  return Select;
}((0, _MDCFoundation.withFoundation)({
  constructor: _mdc.MDCSelect,
  adapter: {
    addClass: (0, _MDCFoundation.addClass)(),
    removeClass: (0, _MDCFoundation.removeClass)(),
    getValue: function getValue() {
      var value = this.nativeControl_.value;
      return value === '' && this.props.placeholder ? ' ' : value;
    }
  }
}));

Object.defineProperty(Select, 'displayName', {
  enumerable: true,
  writable: true,
  value: 'Select'
});
exports.default = Select;



//////////////////
// WEBPACK FOOTER
// ./node_modules/rmwc/Select/index.js
// module id = 67
// module chunks = 0